export default __webpack_public_path__ + "static/media/fpb60000.a223d898.png";